import { Pipe, PipeTransform } from '@angular/core';
import {Utils} from "../../../core/helpers/Utils";

@Pipe({
    name: 'isFeatureEnabled',
    standalone: false
})
export class FeatureTogglePipe implements PipeTransform {
    transform(featureName: string): boolean {
        if (!featureName) {
            return true;
        }
        return Utils.hasFeatureFlag(featureName);
    }
}
